import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import {Link} from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ConstructionIcon from "@mui/icons-material/Construction";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import React from "react";
import {useDispatch} from "react-redux";
import {changeContract} from "../Contract/contractSlice";
import {changeWork} from "../Work/workSlice";
import {changeWorkQueue} from "../WorkQueue/workQueueSlice";
import {changeWorkIssuance} from "../WorkIssuance/workIssuanceSlice";
import InfoDialogue from "../CommonComponents/InfoDialogue";



export default function AppMenuBarClusterLeft({homeBanner,  workingViewBanner}) {

    const currentUserDepartment = localStorage.getItem('department');

    const dispatchData = useDispatch();


    const handleMaintain = () => {
        dispatchData(changeContract({
            participationsTabsIndex: 0,
            residualsTabsVisible: true
            ,contractGridVisible: true
            ,contractDrawerMode: null
            ,contractDrilldownVisible: false
            ,contractSearchVisible: false
            ,contractConfigVisible: false
            ,contractView: null
            ,participationsTabsVisible: false
            ,royaltiesTabsVisible: false
            ,cGridRefresh: false
            ,module: 'Residuals',
            contractGridAPI: "CBA"
        }))
    };


    const handleWork = () => {
        dispatchData(changeContract({
            residualsTabsVisible: false
            ,contractGridVisible: false
            ,contractDrawerMode: null
            ,contractDrilldownVisible: false
            ,contractSearchVisible: false
            ,contractConfigVisible: false
            ,contractView: null
            ,participationsTabsVisible: false
            ,royaltiesTabsVisible: false
            ,cGridRefresh: false
            // ,module: 'Residuals',
            // contractGridAPI: "CBA"
        }))
        dispatchData(changeWork({workTabsIndex: 2,
            searchScreenVisible: false,
            workDashboardVisible: false,
            workContractVisible: true,
            workIssuanceVisible: false,
            propertyId: 0}));
        dispatchData(changeWorkIssuance({            calcSearchProductId: 0, calcTabState: true, payTabState: false, owedGridState: true, obligationGridState: false,
            offsetsGridState: false,paymentGridState: false,fringeGridState: false,taxGridState: false,expenseGridState: false,
            requestGridState: false, confirmationGridState: false,clearData: true, fetchProductId: 0}));
        dispatchData(changeWorkQueue({selectedContractId: 0, selectedContractName: null, workQueueFinalize: false,
            methodTabsState: true, propertySearchState: true, unstructuredSearchState: false,
            statsViewState: false, propertyDropdownTitleId: null, bigAddButtonDisplay: true}))

    };


    return (
        <Box sx={{ display: { xs: 'none', md: 'flex' } }}>


            <Tooltip  enterDelay={1000}  title={"Home"}>
                <Link to={"/"}>
                    <IconButton size="large" aria-label="x"
                                style={{ color: 'white' }}
                    >
                        <Badge badgeContent={0} color="error">
                            <HomeOutlinedIcon
                                onClick={homeBanner}
                            />
                        </Badge>
                    </IconButton>
                </Link>
            </Tooltip>


            <Tooltip  enterDelay={1000}  title={"Maintain"}>
                <Link to={
                    currentUserDepartment === "Residuals" ? "/ResidualsFrontend" :
                        currentUserDepartment === "Participations" ? "/ParticipationsFrontend" :
                            currentUserDepartment === "Royalties" ? "/RoyaltiesFrontend" : "/"
                }>
                    <IconButton size="large" aria-label="y"
                                style={{ color: 'white' }}
                    >
                        <Badge badgeContent={0} color="error">
                            <ConstructionIcon
                                onClick={handleMaintain}
                            />
                        </Badge>
                    </IconButton>
                </Link>
            </Tooltip>



            <Tooltip  enterDelay={1000}  title={"Work"}>
                <Link to={"/Work"}>
                    <IconButton size="large" aria-label=""
                                style={{ color: 'white' }}
                    >
                        <Badge badgeContent={0} color="error">
                            <WorkOutlineIcon
                                onClick={handleWork}
                                // onClick={workingViewBanner}
                            />
                        </Badge>
                    </IconButton>
                </Link>
            </Tooltip>
            {/*<InfoDialogue/>*/}




        </Box>
    )

}